/**
 * Public menu endpoints. No auth required to read; admin mutations live
 * under /admin and are added in Phase 5.
 */
import type { ApiResponse, MenuCategory, MenuItem } from '@cracked-mug/shared';
import { api } from './api';

export interface MenuPayload {
  categories: MenuCategory[];
  items: MenuItem[];
}

function unwrap<T>(payload: ApiResponse<T>): T {
  if (!payload.success) {
    throw new Error(payload.error);
  }
  return payload.data;
}

export async function fetchMenu(): Promise<MenuPayload> {
  const res = await api.get<ApiResponse<MenuPayload>>('/menu');
  return unwrap(res.data);
}

export async function fetchMenuItem(itemId: string): Promise<MenuItem> {
  const res = await api.get<ApiResponse<MenuItem>>(`/menu/items/${itemId}`);
  return unwrap(res.data);
}
